import { useGetMyWorkerContractQuery } from "./api/workContractApiSlice"
import WorkerContractDetail from "./components/WorkerContractDetail"

export default function MyWorkContract() {

    const {
        data: workerContract,
        isSuccess,
        isError
    } = useGetMyWorkerContractQuery()

    if (isSuccess)
        return <WorkerContractDetail contractDetail={workerContract} />
}